import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { createFeatureStateSelector, createSelector } from "mini-rx-store";
//#region src/store/spa-app-selector.ts
var spa_app_selector_exports = /* @__PURE__ */ __exportAll({
	getInitStatusSelector: () => getInitStatusSelector,
	getLoadingSelector: () => getLoadingSelector,
	getOfflineSelector: () => getOfflineSelector,
	selectAuthUser: () => selectAuthUser
});
var getSpaAppFeatureState = createFeatureStateSelector("spaApp");
var getLoadingSelector = createSelector(getSpaAppFeatureState, (state) => {
	const orderByCreation = [...state.loadingState].sort((a, b) => (a.creation?.getTime() || 0) - (b.creation?.getTime() || 0));
	const loadings = [];
	const mainLoading = orderByCreation.filter((a) => !a.smallBackground);
	if (mainLoading.length > 0) loadings.push(mainLoading[0]);
	const smallLoading = orderByCreation.filter((a) => a.smallBackground);
	if (smallLoading.length > 0) loadings.push(smallLoading[0]);
	return loadings;
});
var getOfflineSelector = createSelector(getSpaAppFeatureState, (state) => state.offline === true);
var getInitStatusSelector = createSelector(getSpaAppFeatureState, (state) => ({
	login: state.user !== void 0,
	indexedDB: state.initIndexDB
}));
var selectAuthUser = createSelector(getSpaAppFeatureState, (state) => ({
	user: state.user,
	loginCheckFinish: state.userLoginDone
}));
//#endregion
export { getInitStatusSelector, getLoadingSelector, getOfflineSelector, selectAuthUser, spa_app_selector_exports };
